<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <thead
    data-slot="table-header"
    :class="cn('[&_th:last-child_div]:border-none [&_tr]:border-b bg-gray-50 hover:bg-gray-50', props.class)"
  >
    <slot />
  </thead>
</template>
